import axiosInstance from "@/api/axios-instance";

export interface CloneRegionResult {
  bundlesCreated: number;
  paymentPagesCreated: number;
  configsCreated: number;
  productsSkipped: number;
}

// Clone a source region's offerings (bundles + product-region-configs) into a
// target region. `priceOverrides` are the preview-computed final amounts in the
// target currency, keyed by source standard_id.
export async function cloneRegion(
  sourceRegionId: string,
  targetRegionId: string,
  priceOverrides?: Record<string, number>,
  // Products to clone. Omit → clone all eligible; provided → only these.
  productIds?: string[],
): Promise<CloneRegionResult> {
  return (
    await axiosInstance.post("/region/clone", {
      sourceRegionId,
      targetRegionId,
      priceOverrides,
      productIds,
    })
  ).data;
}
